export const API_TAG_ROUTES = Object.freeze({
  TAG_CATEGORIES: '/tag/categories',
});
